var map = {
	"./BattleRoyaleAdmin.vue": [
		8987,
		8987
	],
	"./Categories.vue": [
		9712,
		9712
	],
	"./Dashboard.vue": [
		7250,
		8436,
		8924,
		9456,
		652
	],
	"./Extras.vue": [
		6120,
		6120
	],
	"./Gamification.vue": [
		9509,
		9509
	],
	"./HotelDashboard.vue": [
		9336,
		8436,
		8924,
		6955
	],
	"./HotelGroupDashboard.vue": [
		1324,
		8436,
		8924,
		1324
	],
	"./HotelGroupUsers.vue": [
		2102,
		2102
	],
	"./HotelLocations.vue": [
		4128,
		8420,
		4128
	],
	"./HotelRooms.vue": [
		439,
		8420,
		439
	],
	"./Locations.vue": [
		77,
		77
	],
	"./OrderDetails.vue": [
		1845,
		1845
	],
	"./Orders.vue": [
		9386,
		2532,
		8203
	],
	"./OrdersV2.vue": [
		1390,
		1390
	],
	"./PreOrders.vue": [
		607,
		607
	],
	"./ProductExtras.vue": [
		8366,
		8366
	],
	"./ProductForm.vue": [
		8241,
		8241
	],
	"./Products.vue": [
		4144,
		4144
	],
	"./Reports.vue": [
		6449,
		6449
	],
	"./RoomCharges.vue": [
		9546,
		9546
	],
	"./Settings.vue": [
		760,
		760
	],
	"./TableDetail.vue": [
		5609,
		8420,
		5609
	],
	"./Tables.vue": [
		6336,
		6336
	],
	"./UserForm.vue": [
		6695,
		6695
	],
	"./Users.vue": [
		7758,
		7758
	],
	"./WaiterApp.vue": [
		67,
		67
	],
	"./WaiterPos.vue": [
		4072,
		4072
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8771;
module.exports = webpackAsyncContext;